export default __webpack_public_path__ + "static/media/furniture-bg-1.0cd3e90d.png";